import { apiClient } from '@/config/api';

export type AdminBuilding = {
  id: number;
  name: string | null;
  code: string | null;
  project: {
    id: number;
    title: string;
  } | null;
};

export type AdminBox = {
  id: number;
  name: string | null;
  code: string | null;
  uuid: string | null;
  projectId: number | null;
};

export type AdminDevice = {
  id: number;
  name: string | null;
  code: string | null;
  uuid: string | null;
  isOnline: boolean;
  type: { id: number; type: string | null } | null;
  category: { id: number; code: string | null; name: string | null } | null;
  box?: { id: number; name: string | null; code: string | null; uuid: string | null } | null;
  building?: { id: number; name: string | null; code: string | null } | null;
};

export const adminCommonAreasService = {
  async getBuildings(): Promise<AdminBuilding[]> {
    const { data } = await apiClient.get<AdminBuilding[]>('/admin/common-areas/buildings');
    return data;
  },

  async getBoxesForBuilding(buildingId: number): Promise<AdminBox[]> {
    const { data } = await apiClient.get<AdminBox[]>(`/admin/common-areas/buildings/${buildingId}/boxes`);
    return data;
  },

  async getDevicesForBox(boxId: number): Promise<AdminDevice[]> {
    const { data } = await apiClient.get<AdminDevice[]>(`/admin/common-areas/boxes/${boxId}/devices`);
    return data;
  },

  async setDeviceCommonArea(deviceId: number, enabled: boolean): Promise<{ id: number; category: AdminDevice['category'] }> {
    const { data } = await apiClient.put<{ id: number; category: AdminDevice['category'] }>(
      `/admin/common-areas/devices/${deviceId}/common-area`,
      { enabled },
    );
    return data;
  },

  async getDevicesForProject(projectId: number): Promise<AdminDevice[]> {
    const { data } = await apiClient.get<AdminDevice[]>(`/admin/common-areas/projects/${projectId}/devices`);
    return data;
  },
};

